import React from "react";
import { ReactComponent as PartnerEcosystemGridSvg } from "../../../../common/assets/icons/partner-ecosystem-grid.svg";
import { ReactComponent as EngagementDocumentSvg } from "../../../../common/assets/icons/engagement-document.svg";
import { ReactComponent as AssessmentClipboardSvg } from "../../../../common/assets/icons/assessment-clipboard.svg";
import { ReactComponent as AssessmentClipboardWhiteSvg } from "../../../../common/assets/icons/assessment-clipboard-white.svg";
import { ReactComponent as RegisterDealFileSvg } from "../../../../common/assets/icons/register-deal-file.svg";
import { ReactComponent as PartnerProgramAwardSvg } from "../../../../common/assets/icons/partner-program-award.svg";
import { ReactComponent as IntegrationChipSvg } from "../../../../common/assets/icons/integration-chip.svg";
import { ReactComponent as WalletCardSvg } from "../../../../common/assets/icons/wallet-card.svg";
import { ReactComponent as MobileDeviceSvg } from "../../../../common/assets/icons/mobile-device.svg";
import { ReactComponent as IdpShieldSvg } from "../../../../common/assets/icons/idp-shield.svg";

type AdminHomeIconProps = {
  className?: string;
  width?: number | string;
  height?: number | string;
};

const wrap =
  (Svg: React.FC<React.SVGProps<SVGSVGElement>>): React.FC<AdminHomeIconProps> =>
  ({ className, width = 24, height = 24 }) =>
    <Svg className={className} width={width} height={height} aria-hidden />;

export const PartnerEcosystemGridIcon = wrap(PartnerEcosystemGridSvg);
export const EngagementDocumentIcon = wrap(EngagementDocumentSvg);
export const AssessmentClipboardIcon = wrap(AssessmentClipboardSvg);
export const AssessmentClipboardWhiteIcon = wrap(AssessmentClipboardWhiteSvg);
export const RegisterDealFileIcon = wrap(RegisterDealFileSvg);
export const PartnerProgramAwardIcon = wrap(PartnerProgramAwardSvg);
export const IntegrationChipIcon = wrap(IntegrationChipSvg);
export const WalletCardIcon = wrap(WalletCardSvg);
export const MobileDeviceIcon = wrap(MobileDeviceSvg);
export const IdpShieldIcon = wrap(IdpShieldSvg);

export type AdminHomeCustomIconId =
  | "partner-ecosystem-grid"
  | "engagement-document"
  | "assessment-clipboard"
  | "assessment-clipboard-white"
  | "register-deal-file"
  | "partner-program-award"
  | "integration-chip"
  | "wallet-card"
  | "mobile-device"
  | "idp-shield";

const ADMIN_HOME_CUSTOM_ICONS: Record<
  AdminHomeCustomIconId,
  React.FC<AdminHomeIconProps>
> = {
  "partner-ecosystem-grid": PartnerEcosystemGridIcon,
  "engagement-document": EngagementDocumentIcon,
  "assessment-clipboard": AssessmentClipboardIcon,
  "assessment-clipboard-white": AssessmentClipboardWhiteIcon,
  "register-deal-file": RegisterDealFileIcon,
  "partner-program-award": PartnerProgramAwardIcon,
  "integration-chip": IntegrationChipIcon,
  "wallet-card": WalletCardIcon,
  "mobile-device": MobileDeviceIcon,
  "idp-shield": IdpShieldIcon,
};

export const AdminHomeCustomIcon: React.FC<
  AdminHomeIconProps & { name: AdminHomeCustomIconId }
> = ({ name, ...props }) => {
  const Icon = ADMIN_HOME_CUSTOM_ICONS[name];
  return <Icon {...props} />;
};
